import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 17h14.4a3 3 0 0 0 2.5 -1.34l3.1 -4.66h-6.23a4 4 0 0 0 -1.49 .29l-3.56 1.42a4 4 0 0 1 -1.49 .29h-5.73z","key":"svg-0"}],["path",{"d":"M6 13l1.5 -5","key":"svg-1"}],["path",{"d":"M6 8h8l2 3","key":"svg-2"}]]

const IconSpeedboat = createReactComponent('outline', 'speedboat', 'Speedboat', __iconNode);

export default IconSpeedboat;